<template>
  <div id="notificationsComponent">
    <page-title
      :heading="heading"
      :subheading="subheading"
      :icon="icon"
    ></page-title>
    <v-container>
      <v-layout class="mb-2" row wrap>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="notificationSearch"
          :label="$t('general.search')"
          clearable
          append-outer-icon="search"
        >
        </v-text-field>
      </v-layout>
      <v-data-table
        :search="notificationSearch"
        class="elevation-2"
        :headers="headers"
        :items="notifications"
        :loading="loadingItems"
        :rows-per-page-items="[10, 15, 25]"
        :pagination.sync="pagination"
      >
        <template v-slot:headers="props">
          <tr class="bg-heavy-rain">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column',
                header.sortable ? 'sortable' : '',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : '',
              ]"
              :style="header.hidden ? 'display: none;' : ''"
              @click="changeSort(header.value)"
            >
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable"
                  >arrow_upward</v-icon
                >
                {{ header.text }}
              </h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr style="border-bottom: none">
            <!-- <td class="text-sm-center">{{props.item.id}}</td> -->
            <td class="text-sm-center">{{ props.item.application.name }}</td>
            <td class="text-sm-center">{{ props.item.title }}</td>
            <td class="text-sm-center d-none" v-html="props.item.message"></td>
            <td class="text-sm-center">
              {{ props.item.notification_type.name }}
            </td>
            <td class="text-sm-center">
            <v-icon v-if="props.item.status" color="green">mdi-check-circle</v-icon>
            <v-icon v-else color="lightgrey">mdi-timer-sand</v-icon>
            </td>
            <td class="text-sm-center">{{ date(props.item.created_at) }}</td>
            <td class="text-sm-center">{{ time(props.item.created_at) }}</td>
            <td class="justify-end layout px-2">
              <v-tooltip bottom>
                <template>
                  <v-btn
                    outline
                    icon
                    color="info"
                    slot="activator"
                    small
                    :disabled="props.item.status === 1"
                    @click="put(props.item)"
                  >
                    <v-icon small>check</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('notifications.markAsRead') }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template>
                  <v-btn
                    outline
                    icon
                    color="info"
                    small
                    slot="activator"
                    v-if="props.item.notification_type_id >= 2"
                    @click="
                          props.item.notification_type_id === 2 ? toRoute('/validate_expenses')
                                                                : props.item.notification_type_id === 3
                                                                ? toRoute('/rejected_expenses') : toRoute('/approvals/validate-request')
                    "
                  >
                    <v-icon small>visibility</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('general.view') }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template>
                  <v-btn
                    outline
                    icon
                    color="error"
                    small
                    slot="activator"
                    @click="remove(props.item)"
                  >
                    <v-icon small>delete</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('general.delete') }}</span>
              </v-tooltip>
            </td>
          </tr>
          <tr>
            <td colspan="7"><span v-html="props.item.message"></span></td>
          </tr>
        </template>
      </v-data-table>
      <v-dialog v-model="removeDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">
              {{ $t('notifications.delete') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('notifications.confirmDelete') }}</p>
            <p class="font-weight-black">
              <span class="error--text">{{ $t('notifications.title') }}: </span
              >"{{ removedItem.title }}"
            </p>
            <p class="font-weight-black">
              <span class="error--text">{{ $t('general.date') }}: </span>"{{
                removedItem.created_at
              }}"
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="removeDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="deleteItem(removedItem)"
            >
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: 'NotificationsComponent',
  data() {
    return {
      loading: false,
      loadingItems: true,
      notificationSearch: '',
      dialog: false,
      removeDialog: false,
      valid: true,
      removedItem: {},
      notifications: [],
      branches: [],
      branchesCompanies: [],
      companies: [],
      pagination: {
        descending: true,
        sortBy: 'created_at',
        page: 1,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0,
      },
    }
  },
  computed: {
    heading() {
      return this.$t('general.notifications')
    },
    subheading() {
      return ''
    },
    icon() {
      return 'far fa-bell fa-fw icon-color'
    },
    // watch the dialog title
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('branch.add')
        : this.$t('branch.edit')
    },
    rules() {
      return this.$validationRules()
    },
    headers() {
      return [
        // {
        //   text: '#',
        //   align: 'center',
        //   value: 'id',
        //   sortable: true
        // },
        {
          text: this.$t('notifications.application'),
          align: 'center',
          value: 'application.name',
          sortable: true,
        },
        {
          text: this.$t('notifications.title'),
          align: 'center',
          value: 'title',
          sortable: true,
        },
        {
          text: this.$t('notifications.message'),
          align: 'center',
          value: 'message',
          sortable: true,
          hidden: true,
        },
       {
          text: this.$t('notifications.Module'),
          align: 'center',
          value: 'notification_type.name',
          sortable: true,
        },
        {
          text: this.$t('notifications.read'),
          align: 'center',
          value: 'status',
          sortable: true,
        },
        {
          text: this.$t('notifications.date'),
          align: 'center',
          value: 'created_at',
          sortable: true,
        },
        {
          text: this.$t('notifications.time'),
          align: 'center',
          value: 'created_at',
          sortable: true,
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false,
        },
      ]
    },
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  created() {
    this.get()
  },
  methods: {
    changeSort(header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    // Load initial elements
    get() {
      this.$emit('get', {
        application_id: 1,
        context: this,
      })
    },
    put(item) {
      this.$emit('put', {
        item: item,
        context: this,
      })
    },
    refresh() {
      this.get()
      this.$store.dispatch('notifications/lastestNotView', {
        event: {
          context: this,
          application_id: 1,
        },
      })
    },
    remove(item) {
      this.removeDialog = true
      this.removedItem = Object.assign({}, item)
    },
    deleteItem(item) {
      this.loading = true
      this.$store.dispatch('notifications/delete', {
        event: {
          item: item,
          context: this,
        },
      })
    },
    close() {
      this.removeDialog = false
      this.loading = false
      this.removedItem = {}
    },
    toRoute(route) {
      this.$router.push(route)
    },
    date(value) {
      return value.substr(0, 10)
    },
    time(value) {
      return value.substr(11, 19)
    },
  },
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/notifications.component.vue